export default __webpack_public_path__ + "static/media/DSC02050.23296939.jpg";